import React from 'react';
import divider from '../../assets/divider-img.png';
import e1 from '../../assets/home-feature/hfp1.png';
import e2 from '../../assets/home-feature/hfp2.png';
import e3 from '../../assets/home-feature/hfp3.png';
import e4 from '../../assets/home-feature/hfp4.png';

const HomeFeature = () => {
  const slides = [
    {
      image: e1,
      subTitle: 'Category',
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: e2,
      subTitle: 'Category',
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: e3,
      subTitle: 'Category',
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: e4,
      subTitle: 'Category',
      title: 'Project Name',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
  ];
  return (
    <div className="home-feature">
      <div className="container">
        <div className="home-experts-wrapper">
          <div className="top-div">
            <h2>Featured Projects</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis n
            </p>
          </div>
          <div className="expert-wrapper">
            <div className="single-expert">
              {slides.map((slide, index) => (
                <div key={index} className="slide expert feature">
                  <div className="slide-content expert-content feature-content">
                    <img src={slide.image} alt="experts" />
                    <div className="slide-info expert-info feature-info">
                      <h5>{slide.subTitle}</h5>
                      <h3>{slide.title}</h3>
                      <p>{slide.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeFeature;
